export enum ServiceURIEnum {
  AGENTS = "AGENTS",
  TEAMS = "TEAMS",
  TOOLS = "TOOLS",
  KNOWLEDGE_BASE = "KNOWLEDGE_BASE",
  GUARDRAILS = "GUARDRAILS",
}
